module.exports = __webpack_public_path__ + "static/img/DSC08027.770cf18.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/nyomtatott-konyhahatfal/varos/DSC08027.jpg
// module id = 593
// module chunks = 0